{
  "common": {
    "empty": "Není vyplněno"
  },
  "labels": {
    "title": "Název",
    "department": "Oddělení",
    "amount": "Částka",
    "status": "Stav",
    "priority": "Priorita",
    "date": "Datum",
    "description": "Popis"
  },
  "ExpandableTextarea": {
    "openInEditor": "Otevřít v editoru",
    "editorTitle": "Editor"
  },
  "UploadInput": {
    "defaultTitle": "Nahrát soubor",
    "uploading": "Nahrávání...",
    "acceptedTypes": "Podporované typy",
    "maxSize": "Max. velikost",
    "maxFiles": "Max. počet souborů",
    "errors": {
      "maxFiles": "Překročen maximální počet souborů:",
      "fileTooBig": "překračuje maximální velikost",
      "invalidType": "má nepodporovaný typ souboru"
    }
  },
  "components": {
    "errorEntry": {
      "withExpected": "{{message}} (očekáváno: <b>{{expected}}</b>)",
      "withActualExpected": "{{message}} (očekáváno: <b>{{expected}}</b>, zadáno: <b>{{actual}}</b>)"
    },
    "signaturePad": {
      "signHere": "Podepište zde",
      "created": "Podpis vytvořen",
      "edit": "Upravit podpis",
      "e-sign": "Elektronický podpis",
      "comfort": "Podepište se pohodlně prstem nebo stylusem",
      "signFull": "Podepsat na celou obrazovku",
      "signed": "Podepsáno",
      "deleteSign": "Smazat podpis",
      "signNormal": "Podepište se pomocí prstu nebo stylusu",
      "finger": "Použijte prst nebo stylus",
      "delete": "Smazat",
      "done": "Hotovo"
    },
    "filterEditorPanel": {
      "clear": "Zrušit výběr"
    },
    "filterSheet": {
      "title": "Filtry a vyhledávání",
      "applyLabel": "Zobrazit výsledky",
      "close": "Zavřít filtry"
    },
    "pageSidebar": {
      "expand": "Zobrazit filtry",
      "collapse": "Skrýt filtry"
    },
    "datepicker": {
      "cancel": "Zrušit",
      "confirm": "Potvrdit"
    },
    "editableField": {
      "save": "Uložit",
      "cancel": "Zrušit"
    },
    "boolean": {
      "TRUE": "Ano",
      "FALSE": "Ne"
    },
    "vatRateSelector": {
      "customRate": "Vlastní sazba…",
      "backToPresets": "Zpět na výběr sazeb"
    },
    "invoicePurpose": {
      "GOODS": "Zboží",
      "SERVICES": "Služby",
      "FREIGHT": "Doprava",
      "SUMMARY": "Souhrnná",
      "PARTIAL": "Dílčí",
      "FINAL": "Konečná",
      "SETTLEMENT": "Zúčtovací",
      "MIXED": "Smíšená (zboží + služby)"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Bankovní převod",
      "CASH": "Hotovost",
      "CARD": "Platební karta",
      "CHECK": "Šek",
      "DIRECT_DEBIT": "Přímé inkaso",
      "CLEARING": "Zápočet",
      "OTHER": "Jiná forma platby"
    },
    "paymentStatus": {
      "UNPAID": "Neproplaceno",
      "PARTIALLY_PAID": "Částečně proplaceno",
      "PAID": "Proplaceno"
    },
    "invoiceType": {
      "INVOICE": "Faktura",
      "CREDIT_NOTE": "Dobropis",
      "DEBIT_NOTE": "Vrubopis",
      "PROFORMA": "Zálohová faktura",
      "ADVANCE": "Daňový doklad k přijaté záloze",
      "RECEIPT": "Účtenka",
      "OTHER": "Jiný typ dokladu"
    },
    "vatMode": {
      "STANDARD": "Standardní DPH",
      "REVERSE_CHARGE": "Přenesená daňová povinnost",
      "EXEMPT_DOMESTIC": "Osvobozeno — tuzemsko",
      "EXEMPT_EU_SUPPLY": "Osvobozeno — dodání do EU",
      "EXEMPT_EXPORT": "Osvobozeno — vývoz mimo EU",
      "EXEMPT_OTHER": "Osvobozeno od daně"
    },
    "filterDialog": {
      "title": "Filtry",
      "actions": {
        "reset": "Obnovit",
        "apply": "Použít"
      },
      "status": {
        "label": "Stav"
      },
      "amount": {
        "label": "Částka",
        "from": "Od",
        "to": "Do"
      },
      "period": {
        "label": "Období",
        "from": "Od",
        "to": "Do"
      },
      "user": {
        "label": "Vytvořil"
      }
    },
    "invoiceListItem": {
      "documentType": {
        "UNKNOWN": "Neznámý",
        "INVOICE": "Faktura",
        "CREDIT_NOTE": "Dobropis",
        "DEBIT_NOTE": "Vrubopis",
        "PROFORMA": "Zálohová faktura",
        "ADVANCE": "Daňový doklad k přijaté záloze",
        "RECEIPT": "Účtenka",
        "OTHER": "Jiný typ dokladu"
      },
      "validationStatus": {
        "UNPROCESSED": "Nezpracováno",
        "PENDING": "Zpracovává se",
        "SUCCESS": "Validováno",
        "WARNING": "Varování",
        "ERROR": "Chyba validace",
        "WAITING_FOR_CREDITS": "Čeká na kredity"
      },
      "compositeStatus": {
        "FOR_EDIT": "K editaci",
        "FOR_APPROVAL": "Ke schválení",
        "FOR_EXPORT": "K zaúčtování",
        "FOR_PAYMENT": "K proplacení",
        "FOR_EXPORT_AND_PAYMENT": "K zaúčtování a proplacení",
        "REJECTED": "Zamítnuto",
        "COMPLETED": "Ukončeno",
        "ARCHIVED": "Archivováno"
      },
      "labels": {
        "dueDate": "Splatnost",
        "issueDate": "Vystaveno",
        "exclVat": "bez DPH",
        "convertedAmount": "≈ {{amount}}",
        "convertedAmountHint": "Přepočteno do účetní měny",
        "overdue": "Po splatnosti"
      }
    },
    "validationBanner": {
      "severity": {
        "error": "Doplň",
        "warning": "Zkontroluj",
        "info": "Pro informaci"
      },
      "scrollTo": "Přejít na pole",
      "stored": "uloženo",
      "calculated": "vypočteno"
    },
    "validationTooltip": {
      "overflowMore": "+{{count}} dalších"
    },
    "lineChangesModal": {
      "modal": {
        "lineChanges": "Změny položek",
        "addedLines": "Přidáno",
        "removedLines": "Odebráno",
        "modifiedLines": "Upraveno",
        "field": "Pole",
        "from": "Před",
        "to": "Po",
        "noDetails": "Žádné změny položek."
      },
      "fieldLabels": {
        "description": "Název",
        "quantity": "Množství",
        "unitPrice": "Jedn. cena",
        "unitPriceInclVat": "Jedn. cena (s DPH)",
        "unitPriceNoVat": "Jedn. cena (bez DPH)",
        "totalAmount": "Celková částka",
        "totalAmountInclVat": "Celkem s DPH",
        "totalAmountNoVat": "Celkem bez DPH",
        "vatRate": "Sazba DPH",
        "vatAmount": "Částka DPH",
        "vatMode": "Režim DPH",
        "unit": "Jednotka",
        "costCenterId": "Nákladové středisko",
        "discountPercent": "Sleva",
        "ean": "EAN",
        "code": "Kód",
        "recyclingFee": "Recyklační poplatek",
        "classification": "Klasifikace",
        "productType": "Typ položky",
        "estimatedUnitPrice": "Odhad. jedn. cena",
        "estimatedTotalAmountNoVat": "Odhad. celkem bez DPH",
        "neededBy": "Termín dodání",
        "costCenter": "Středisko",
        "job": "Zakázka",
        "expectedDeliveryDate": "Termín dodání",
        "quantityReceived": "Přijato",
        "notes": "Poznámka"
      },
      "lineChanges": {
        "fieldCleared": "odstraněno",
        "lineNumber": "Položka {{number}}"
      }
    },
    "vatSummaryChangesModal": {
      "modal": {
        "title": "Změny rekapitulace DPH",
        "addedRates": "Přidáno",
        "removedRates": "Odebráno",
        "modifiedRates": "Upraveno",
        "field": "Pole",
        "from": "Před",
        "to": "Po",
        "noDetails": "Žádné změny rekapitulace DPH."
      },
      "fieldLabels": {
        "vatRate": "Sazba DPH",
        "netAmount": "Základ",
        "vatAmount": "DPH"
      },
      "vatChanges": {
        "fieldCleared": "odstraněno"
      }
    },
    "timezoneSelect": {
      "city": {
        "UTC": "Koordinovaný světový čas",
        "Europe/London": "Londýn",
        "Europe/Dublin": "Dublin",
        "Europe/Lisbon": "Lisabon",
        "Europe/Prague": "Praha",
        "Europe/Bratislava": "Bratislava",
        "Europe/Vienna": "Vídeň",
        "Europe/Warsaw": "Varšava",
        "Europe/Budapest": "Budapešť",
        "Europe/Berlin": "Berlín",
        "Europe/Paris": "Paříž",
        "Europe/Rome": "Řím",
        "Europe/Madrid": "Madrid",
        "Europe/Amsterdam": "Amsterodam",
        "Europe/Brussels": "Brusel",
        "Europe/Zurich": "Curych",
        "Europe/Stockholm": "Stockholm",
        "Europe/Oslo": "Oslo",
        "Europe/Copenhagen": "Kodaň",
        "Europe/Luxembourg": "Lucemburk",
        "Europe/Zagreb": "Záhřeb",
        "Europe/Belgrade": "Bělehrad",
        "Europe/Helsinki": "Helsinky",
        "Europe/Athens": "Atény",
        "Europe/Bucharest": "Bukurešť",
        "Europe/Sofia": "Sofie",
        "Europe/Vilnius": "Vilnius",
        "Europe/Riga": "Riga",
        "Europe/Tallinn": "Tallinn",
        "Europe/Kyiv": "Kyjev",
        "Europe/Istanbul": "Istanbul",
        "Europe/Moscow": "Moskva",
        "America/New_York": "New York",
        "America/Chicago": "Chicago",
        "America/Denver": "Denver",
        "America/Los_Angeles": "Los Angeles",
        "America/Toronto": "Toronto",
        "America/Vancouver": "Vancouver",
        "America/Sao_Paulo": "São Paulo",
        "America/Mexico_City": "Ciudad de México",
        "America/Bogota": "Bogotá",
        "America/Lima": "Lima",
        "America/Santiago": "Santiago de Chile",
        "America/Argentina/Buenos_Aires": "Buenos Aires",
        "Asia/Dubai": "Dubaj",
        "Asia/Riyadh": "Rijád",
        "Asia/Kolkata": "Kalkata",
        "Asia/Dhaka": "Dháka",
        "Asia/Bangkok": "Bangkok",
        "Asia/Singapore": "Singapur",
        "Asia/Kuala_Lumpur": "Kuala Lumpur",
        "Asia/Hong_Kong": "Hongkong",
        "Asia/Shanghai": "Šanghaj",
        "Asia/Taipei": "Tchaj-pej",
        "Asia/Tokyo": "Tokio",
        "Asia/Seoul": "Soul",
        "Asia/Jakarta": "Jakarta",
        "Asia/Jerusalem": "Jeruzalém",
        "Asia/Manila": "Manila",
        "Asia/Ho_Chi_Minh": "Ho Či Min",
        "Africa/Johannesburg": "Johannesburg",
        "Africa/Cairo": "Káhira",
        "Africa/Lagos": "Lagos",
        "Africa/Nairobi": "Nairobi",
        "Australia/Sydney": "Sydney",
        "Australia/Melbourne": "Melbourne",
        "Australia/Perth": "Perth",
        "Pacific/Auckland": "Auckland",
        "Pacific/Honolulu": "Honolulu"
      }
    },
    "reorderableList": {
      "add": "Přidat",
      "moveUp": "Posunout výš: {{item}}",
      "moveDown": "Posunout níž: {{item}}",
      "remove": "Odebrat: {{item}}",
      "moved": "{{item}} – pozice {{n}}",
      "limitReached": "Dosažen limit {{max}} položek"
    },
    "stepper": {
      "done": "hotovo",
      "error": "chyba"
    }
  },
  "modules": {
    "menu": {
      "profile": "Můj profil",
      "logout": "Odhlásit se",
      "myAccount": "Profil",
      "systemSettings": "Nastavení systému",
      "codeLists": "Číselníky",
      "automation": "Automatizace",
      "settings": "Nastavení",
      "policies": "Zásady a podmínky",
      "profileMenu": "Uživatelské menu",
      "usage": {
        "title": "Využití limitu",
        "plan": "Tarif: {{name}}",
        "count": "{{used}} / {{limit}} dokladů",
        "countUnlimited": "{{used}} / ∞ dokladů",
        "remaining_one": "zbývá {{count}} doklad",
        "remaining_few": "zbývají {{count}} doklady",
        "remaining_many": "zbývá {{count}} dokladu",
        "remaining_other": "zbývá {{count}} dokladů",
        "resetsOn": "Limit se obnoví {{date}}",
        "progressAriaLabel": "Využití limitu: {{label}}",
        "creditsTitle": "Čerpání kreditů",
        "creditsCount": "{{used}} / {{limit}} kreditů",
        "creditsAvailable_one": "{{count}} kredit k dispozici",
        "creditsAvailable_few": "{{count}} kredity k dispozici",
        "creditsAvailable_many": "{{count}} kreditu k dispozici",
        "creditsAvailable_other": "{{count}} kreditů k dispozici",
        "creditsRemaining_one": "zbývá {{count}} kredit",
        "creditsRemaining_few": "zbývají {{count}} kredity",
        "creditsRemaining_many": "zbývá {{count}} kreditu",
        "creditsRemaining_other": "zbývá {{count}} kreditů",
        "extraRemaining": "+{{credits}} navíc",
        "creditsRenewOn": "Kredity se obnoví {{date}}",
        "endsOn": "Končí {{date}}",
        "noPeriod": "Žádné běžící období",
        "exhausted": "Kredity došly",
        "creditsProgressAriaLabel": "Čerpání kreditů: {{label}}",
        "remaining": "Zbývá {{count}}",
        "creditsRemaining": "Zbývá {{count}}"
      },
      "accounts": {
        "title": "Organizace"
      },
      "invitations": {
        "title": "Pozvánky",
        "join": "Připojit se",
        "joinAria": "Připojit se do organizace {{name}}"
      }
    },
    "filterBar": {
      "stats": {
        "all": "Celkem",
        "pending": "Ke schválení",
        "approved": "Schváleno",
        "overdue": "Po splatnosti"
      },
      "searchPlaceholder": "Hledat...",
      "filters": "Filtry",
      "sortBy": "Řadit podle",
      "direction": "Směr",
      "descending": "Sestupně",
      "ascending": "Vzestupně",
      "sortFields": {
        "date": "Datum",
        "amount": "Částka",
        "vendor": "Dodavatel",
        "number": "Číslo"
      }
    },
    "receipt": {
      "item": "Položka",
      "itemName": "Položka",
      "quantity": "KS",
      "pricePerUnit": "Cena/ks",
      "vat": "DPH",
      "totalPrice": "Celkem",
      "price": "Cena",
      "totalWithoutVat": "Bez DPH",
      "vatAmount": "DPH",
      "total": "CELKEM",
      "payment": "Platba",
      "status": "Stav",
      "inclVat": "vč. DPH",
      "footerMessage": "Děkujeme za nákup",
      "merchantId": "IČO",
      "merchantTaxId": "DIČ",
      "supplier": "Dodavatel",
      "customer": "Odběratel",
      "companyId": "IČO",
      "taxId": "DIČ"
    },
    "sidebar": {
      "statsTitle": "Statistiky",
      "stats": {
        "all": "Celkem",
        "pending": "Ke schválení",
        "approved": "Schváleno",
        "overdue": "Po splatnosti"
      },
      "filtersTitle": "Filtry a vyhledávání",
      "searchPlaceholder": "Hledat...",
      "filters": "Filtry",
      "sortBy": "Řadit podle",
      "direction": "Směr",
      "descending": "Sestupně",
      "ascending": "Vzestupně",
      "reset": "Resetovat",
      "sortFields": {
        "date": "Datum",
        "amount": "Částka",
        "vendor": "Dodavatel",
        "number": "Číslo"
      }
    },
    "confirmActionModal": {
      "cancel": "Zrušit"
    },
    "errorModal": {
      "close": "Zavřít"
    },
    "modals": {
      "inviteUser": {
        "title": "Pozvat uživatele",
        "description": "Zadejte e-mail a vyberte roli nového uživatele. Bude mu odeslána pozvánka.",
        "fields": {
          "email": "E-mail",
          "role": "Role"
        },
        "noRolesHint": "Bez další role bude pozván jako Člen. {{description}}",
        "placeholders": {
          "email": "uzivatel@firma.cz"
        },
        "actions": {
          "cancel": "Zrušit"
        },
        "status": {
          "inviting": "Odesílání…"
        },
        "errors": {
          "emailRequired": "E-mail je povinný",
          "emailInvalid": "Neplatný formát e-mailu",
          "inviteError": "Nepodařilo se odeslat pozvánku",
          "emailAlreadyRegistered": "Tento e-mail je již registrován v jiné organizaci",
          "emailAlreadyInOrg": "Uživatel s tímto e-mailem již existuje ve vaší organizaci",
          "invitationAlreadySent": "Pozvánka na tento e-mail již byla odeslána. Použijte funkci Znovu odeslat."
        }
      },
      "editUser": {
        "title": "Upravit uživatele",
        "description": "Změňte jméno, příjmení nebo roli uživatele.",
        "fields": {
          "email": "E-mail",
          "firstName": "Jméno",
          "lastName": "Příjmení",
          "role": "Role",
          "active": "Aktivní"
        },
        "placeholders": {
          "firstName": "Např. Jan",
          "lastName": "Např. Novák"
        },
        "actions": {
          "save": "Uložit",
          "cancel": "Zrušit"
        },
        "status": {
          "updating": "Ukládání…"
        },
        "errors": {
          "firstNameRequired": "Jméno je povinné",
          "lastNameRequired": "Příjmení je povinné",
          "updateError": "Nepodařilo se aktualizovat uživatele"
        }
      },
      "supplier": {
        "titleAdd": "Přidat partnera",
        "titleEdit": "Upravit partnera",
        "fields": {
          "name": "Název",
          "code": "Kód",
          "companyId": "IČO",
          "vatId": "DIČ pro DPH / VAT ID",
          "taxId": "DIČ",
          "vatPayerType": "Typ plátce DPH",
          "email": "E-mail",
          "phone": "Telefon",
          "streetName": "Ulice",
          "buildingNumber": "Číslo popisné",
          "city": "Město",
          "postalCode": "PSČ",
          "countryCode": "Kód země",
          "isActive": "Aktivní",
          "isSupplier": "Dodavatel",
          "isCustomer": "Odběratel",
          "mobile": "Mobil",
          "website": "Web"
        },
        "placeholders": {
          "name": "Např. ACME s.r.o.",
          "code": "Např. DOD-001",
          "companyId": "Např. 12345678",
          "vatId": "Např. CZ12345678",
          "taxId": "Např. CZ12345678",
          "vatPayerTypeNone": "Neuvedeno",
          "email": "Např. info@partner.cz",
          "phone": "Např. +420 123 456 789",
          "streetName": "Např. Hlavní",
          "buildingNumber": "Např. 123",
          "city": "Např. Praha",
          "postalCode": "Např. 11000",
          "countryCode": "Např. CZ",
          "countryCodeNone": "— Vyberte zemi —",
          "mobile": "Např. +420 777 123 456",
          "website": "Např. www.partner.cz"
        },
        "hints": {
          "vatId": "Číslo, pod kterým je subjekt registrován k DPH. U většiny českých firem shodné s DIČ."
        },
        "ares": {
          "label": "Načíst údaje podle IČO nebo DIČ",
          "placeholder": "Zadejte IČO nebo DIČ",
          "button": "Načíst z ARES",
          "loading": "Načítání…",
          "applied": "Údaje byly načteny z ARES a předvyplněny do formuláře.",
          "vatIdLoading": "Načítám DIČ pro DPH z ARES…",
          "vatIdFilled": "DIČ pro DPH doplněno z ARES"
        },
        "sections": {
          "address": "Adresa",
          "contact": "Kontakt",
          "role": "Role"
        },
        "actions": {
          "saving": "Ukládání…",
          "save": "Uložit",
          "create": "Vytvořit",
          "cancel": "Zrušit"
        },
        "errors": {
          "nameRequired": "Název je povinný",
          "companyIdRequired": "IČO je povinné",
          "emailInvalid": "Neplatný formát e-mailu",
          "aresInvalidInput": "Zadejte platné IČO nebo DIČ",
          "aresNotFound": "Firma nebyla v registru ARES nalezena",
          "aresUnavailable": "Služba ARES je momentálně nedostupná, zkuste to prosím později",
          "websiteInvalid": "Zadejte webovou adresu http(s), např. www.partner.cz"
        },
        "links": {
          "openWebsite": "Otevřít web"
        }
      },
      "address": {
        "title": "Upravit adresu",
        "description": "Vyplňte jednotlivá pole adresy. Všechna pole jsou nepovinná.",
        "fields": {
          "streetName": "Ulice",
          "buildingNumber": "Č. p. / č. o.",
          "city": "Město",
          "postalCode": "PSČ",
          "countryCode": "Kód země",
          "countryCodeHint": "Dvoupísmenný kód dle ISO 3166-1 alpha-2 (např. CZ, SK, DE)",
          "countryCodeNone": "— Žádná země —"
        },
        "actions": {
          "save": "Uložit adresu",
          "cancel": "Zrušit"
        },
        "errors": {
          "saveError": "Adresu se nepodařilo uložit. Zkuste to prosím znovu."
        }
      },
      "generateApiKey": {
        "title": "Vygenerovat nový klíč",
        "fields": {
          "name": "Název",
          "description": "Popis",
          "rateLimit": "Limit",
          "roles": "Role"
        },
        "placeholders": {
          "name": "Např. Produkční API",
          "description": "Volitelný popis účelu klíče",
          "rateLimitHint": "Požadavků za minutu (Výchozí: 1000)"
        },
        "actions": {
          "cancel": "Zrušit"
        },
        "status": {
          "generating": "Generování…"
        },
        "errors": {
          "nameRequired": "Název je povinný",
          "rateLimitInvalid": "Limit musí být kladné číslo",
          "createError": "Chyba při vytváření API klíče"
        }
      },
      "apiKeyDisplay": {
        "title": "API klíč vytvořen",
        "warningTitle": "Důležité",
        "warningMessage": "Tento klíč se zobrazí pouze jednou. Zkopírujte si jej nyní a bezpečně jej uložte. Pokud jej ztratíte, budete muset vytvořit nový.",
        "yourKey": "Váš klíč",
        "fields": {
          "name": "Název",
          "prefix": "Prefix",
          "rateLimit": "Limit",
          "createdAt": "Vytvořeno"
        },
        "close": "Zavřít",
        "copied": "Zkopírováno",
        "copyKey": "Kopírovat klíč"
      },
      "editBankingDetails": {
        "title": "Upravit bankovní spojení",
        "fields": {
          "accountNumber": "Číslo účtu",
          "accountNumberWithCode": "Číslo účtu",
          "bankCode": "Kód banky",
          "bankName": "Název banky",
          "iban": "IBAN",
          "swift": "SWIFT / BIC",
          "varSymb": "Variabilní symbol",
          "constSymb": "Konstantní symbol",
          "specSymb": "Specifický symbol"
        },
        "actions": {
          "cancel": "Zrušit",
          "saving": "Ukládání…",
          "save": "Uložit"
        },
        "warnings": {
          "invalidSwift": "Neplatný formát SWIFT/BIC (např. GIBACZPX nebo GIBACZPXXXX)",
          "invalidBankCode": "Kód banky by měl být 4-místné číslo (např. 0800)",
          "invalidIban": "Neplatný formát IBAN (např. CZ6508000000192000145399)",
          "invalidDataTitle": "Varování: Neplatný formát údajů",
          "invalidDataBody": "Zkontrolujte zvýrazněná pole. Data lze uložit, ale mohou být nesprávná."
        },
        "errors": {
          "atLeastOneField": "Vyplňte alespoň jedno pole",
          "saveError": "Nepodařilo se uložit bankovní spojení. Zkuste to prosím znovu."
        }
      },
      "editVatSummary": {
        "title": "Souhrn DPH",
        "description": "Editace sazeb DPH a celkových částek",
        "vatRatesTitle": "Rekapitulace DPH podle sazeb",
        "noVatRates": "Žádné sazby DPH (kalkulováno z položek)",
        "totalsTitle": "Celkové částky",
        "totalWithoutVat": "Celkem bez DPH",
        "totalVatFromRecap": "Celkem DPH (z rekapitulace)",
        "totalToPay": "Celkem k úhradě",
        "vatRateLabel": "Sazba DPH",
        "currencyLabel": "Měna",
        "currencyPlaceholder": "Vyhledat měnu",
        "exchangeRateLabel": "Kurz",
        "exchangeRateLine": "1 {{from}} = {{rate}} {{to}}",
        "exchangeRateHint": "Kolik {{to}} odpovídá 1 {{from}}",
        "baseLabel": "Základ ({{currency}})",
        "vatLabel": "DPH ({{currency}})",
        "totalInclVatLabel": "S DPH ({{currency}})",
        "vatLabels": {
          "total": "Celkem"
        },
        "actions": {
          "cancel": "Zrušit",
          "saving": "Ukládání…",
          "save": "Uložit změny",
          "addRate": "Přidat sazbu",
          "removeRate": "Odebrat řádek",
          "confirmRemove": "Ano, odebrat",
          "cancelRemove": "Zrušit",
          "confirmAdd": "Potvrdit řádek",
          "allRatesAdded": "Všechny povolené sazby jsou zobrazeny",
          "fillFromLines": "Doplnit z položek"
        },
        "phantom": {
          "newRate": "Nová sazba…"
        },
        "removeConfirm": {
          "title": "Odebrat sazbu DPH?",
          "body": "Tento řádek sazby bude odebrán z rekapitulace. Zpět ho přidáte pomocí tlačítka „Přidat sazbu“ nad tabulkou."
        },
        "fillConfirm": {
          "title": "Přepsat z položek?",
          "body": "Některé řádky již obsahují hodnoty, které se liší od položek dokladu. Doplnění je přepíše vypočtenými částkami.",
          "confirm": "Přepsat",
          "cancel": "Zrušit"
        },
        "errors": {
          "saveError": "Nepodařilo se uložit souhrn DPH. Zkuste to prosím znovu.",
          "invalidRate": "Sazba musí být číslo v rozsahu 0–100.",
          "duplicateRate": "Tato sazba v rekapitulaci již existuje."
        },
        "warnings": {
          "expectedVat": "Očekávaná DPH:",
          "expectedVatFormula": "= {{base}} {{currency}} × {{rate}} %",
          "expectedNet": "Očekávaný základ:",
          "expectedNetFormula": "= {{vat}} {{currency}} ÷ {{rate}} %",
          "expectedFromLines": "Z položek dokladu",
          "expectedTotal": "Očekáváno: {{expected}} {{currency}}",
          "applyExpected": "Použít očekávanou hodnotu"
        }
      },
      "editInvoiceTotals": {
        "title": "Celkové částky faktury",
        "description": "Editace celkových částek",
        "totalWithoutVat": "Celkem bez DPH",
        "vatAmount": "DPH",
        "totalToPay": "Celkem k úhradě",
        "paymentStatus": "Stav platby",
        "paidAmount": "Proplaceno",
        "accountingExchangeRate": "Účetní kurz",
        "accountingCurrency": "Účetní měna",
        "sectionTotals": "Částky",
        "sectionPayment": "Platba",
        "summary": "Souhrn",
        "accountingConversion": "Přepočet na účetní měnu",
        "exchangeRate": "Směnný kurz",
        "exchangeRateLine": "1 {{from}} = {{rate}} {{to}}",
        "withoutVat": "Bez DPH",
        "total": "Celkem",
        "totalVatAmount": "Celkem DPH",
        "totalAmount": "Celková částka",
        "rounding": "Zaokrouhlení",
        "remainingToPay": "Zbývá k úhradě",
        "recompute": "Přepočítat",
        "hintExpected": "Očekáváno:",
        "suggestedRate": "Očekáváno",
        "suggestedRatePer": "dle {{source}} {{date}}",
        "suggestedRatePerNoDate": "dle {{source}}",
        "rateSourceCNB": "ČNB",
        "rateSourceECB": "ECB",
        "actions": {
          "cancel": "Zrušit",
          "saving": "Ukládání…",
          "save": "Uložit změny",
          "fillFromVatSummary": "Z rekapitulace DPH",
          "fillFromLines": "Z položek",
          "applyExpected": "Použít očekávanou hodnotu",
          "applySuggestedRate": "Použít navrhovaný kurz"
        },
        "errors": {
          "saveError": "Nepodařilo se uložit celkové částky. Zkuste to prosím znovu."
        },
        "roundingAmount": "Zaokrouhlení"
      },
      "editInvoiceLines": {
        "title": "Editace položek faktury",
        "description": "Upravte zvýrazněná pole. Hodnoty se na FE nepřepočítávají – uloží se tak, jak je zadáte.",
        "colEan": "EAN",
        "colCode": "Kód",
        "colName": "Název",
        "colQuantity": "Množství",
        "colUnit": "Jednotka",
        "colUnitPrice": "Jednotková cena",
        "colPricePerUnit": "Cena/ks",
        "colPricePerUnitInclVat": "Cena/ks s DPH",
        "colPricePerUnitNoVat": "Cena/ks bez DPH",
        "colDiscount": "Sleva %",
        "colRecyclingFee": "Recykl. popl.",
        "colVatRate": "Sazba DPH",
        "colVatMode": "Režim DPH",
        "colVatTotal": "DPH celkem",
        "colTotalNoVat": "Celkem bez DPH",
        "colTotal": "Celkem s DPH",
        "totalAmount": "Celkem",
        "totalAmountNoVat": "Celkem bez DPH",
        "colActions": "Akce",
        "unitPriceInclVatToggle": "Jednotkové ceny s DPH",
        "unitPricesLabel": "Jedn. ceny:",
        "unitPricesInclVat": "s DPH",
        "unitPricesExclVat": "bez DPH",
        "noName": "Bez názvu",
        "unitPlaceholder": "ks",
        "addLine": "Přidat položku",
        "addLineShort": "Přidat",
        "recomputeAll": "Dopočítat vše",
        "recomputeAllShort": "Dopočítat",
        "deleteLine": "Smazat položku",
        "recomputeLine": "Dopočítat položku",
        "noLines": "Žádné položky",
        "sectionTitle": "Položky",
        "itemCount_one": "{{count}} položka",
        "itemCount_few": "{{count}} položky",
        "itemCount_other": "{{count}} položek",
        "actions": {
          "cancel": "Zrušit",
          "saving": "Ukládání…",
          "save": "Uložit změny"
        },
        "errors": {
          "saveError": "Nepodařilo se uložit položky faktury. Zkuste to prosím znovu."
        },
        "warnings": {
          "validationTitle": "Položky obsahují chyby",
          "validationBody": "Některé položky obsahují validační chyby. Chybná pole jsou zvýrazněna níže.",
          "applyExpected": "Použít očekávanou hodnotu"
        },
        "hintExpected": "Očekáváno:",
        "unitPriceInclVatSuffix": "s DPH",
        "unitPriceExclVatSuffix": "bez DPH"
      },
      "lineChangesModal": {
        "modal": {
          "lineChanges": "Změny položek",
          "addedLines": "Přidáno",
          "removedLines": "Odebráno",
          "modifiedLines": "Upraveno",
          "field": "Pole",
          "from": "Před",
          "to": "Po",
          "noDetails": "Žádné změny položek."
        },
        "fieldLabels": {
          "description": "Popis",
          "quantity": "Množství",
          "unitPrice": "Jedn. cena",
          "unitPriceInclVat": "Jedn. cena (s DPH)",
          "unitPriceNoVat": "Jedn. cena (bez DPH)",
          "totalAmount": "Celková částka",
          "totalAmountInclVat": "Celkem s DPH",
          "totalAmountNoVat": "Celkem bez DPH",
          "vatRate": "Sazba DPH",
          "vatAmount": "Částka DPH",
          "vatMode": "Režim DPH",
          "unit": "Jednotka",
          "costCenterId": "Nákladové středisko",
          "discountPercent": "Sleva",
          "ean": "EAN",
          "classification": "Klasifikace",
          "recyclingFee": "Recyklační poplatek",
          "code": "Kód",
          "productType": "Typ položky",
          "estimatedUnitPrice": "Odhad. jedn. cena",
          "estimatedTotalAmountNoVat": "Odhad. celkem bez DPH",
          "neededBy": "Termín dodání",
          "costCenter": "Středisko",
          "job": "Zakázka",
          "expectedDeliveryDate": "Termín dodání",
          "quantityReceived": "Přijato",
          "notes": "Poznámka"
        },
        "lineChanges": {
          "fieldCleared": "odstraněno",
          "lineNumber": "Položka {{number}}"
        }
      },
      "vatSummaryChangesModal": {
        "modal": {
          "title": "Změny rekapitulace DPH",
          "addedRates": "Přidáno",
          "removedRates": "Odebráno",
          "modifiedRates": "Upraveno",
          "field": "Pole",
          "from": "Před",
          "to": "Po",
          "noDetails": "Žádné změny rekapitulace DPH."
        },
        "fieldLabels": {
          "vatRate": "Sazba DPH",
          "netAmount": "Základ",
          "vatAmount": "DPH"
        },
        "vatChanges": {
          "fieldCleared": "odstraněno"
        }
      }
    }
  },
  "notifications": {
    "extraction": {
      "busy": {
        "0": "Čmuchám…",
        "1": "Vytěžuji…",
        "2": "Louskám…",
        "3": "Pročítám…",
        "4": "Rozklíčovávám…"
      }
    },
    "completed": "Dokončeno",
    "failed": "Selhalo",
    "locked": "Chráněno heslem",
    "deleted": "Smazáno",
    "emailCompleted": "Vytěženo z e-mailu",
    "invoiceSaved": "Uživatel {{actor}} uložil fakturu",
    "dismiss": "Zavřít",
    "documentExtracted": "Uživatel {{actor}} vytěžil dokument",
    "expand": "Zobrazit vše ({{count}})",
    "invoiceActivity": {
      "VALIDATION": "Validuji doklad…",
      "APPROVAL": "Vyhodnocuji automatické schválení…",
      "MATCHING": "Páruji s objednávkami…"
    },
    "procurementActivity": {
      "APPROVAL": "Vyhodnocuji automatické schválení…",
      "VALIDATION": "Kontroluji doklad…"
    },
    "summary": {
      "extracting_one": "Vytěžuji {{count}} dokument",
      "extracting_few": "Vytěžuji {{count}} dokumenty",
      "extracting_other": "Vytěžuji {{count}} dokumentů",
      "documentExtracted_one": "{{count}} vytěžený dokument",
      "documentExtracted_few": "{{count}} vytěžené dokumenty",
      "documentExtracted_other": "{{count}} vytěžených dokumentů",
      "extractionDone_one": "{{count}} dokončený dokument",
      "extractionDone_few": "{{count}} dokončené dokumenty",
      "extractionDone_other": "{{count}} dokončených dokumentů",
      "extractionFailed_one": "{{count}} neúspěšný dokument",
      "extractionFailed_few": "{{count}} neúspěšné dokumenty",
      "extractionFailed_other": "{{count}} neúspěšných dokumentů",
      "extractionLocked_one": "{{count}} dokument vyžaduje heslo",
      "extractionLocked_few": "{{count}} dokumenty vyžadují heslo",
      "extractionLocked_other": "{{count}} dokumentů vyžaduje heslo",
      "invoiceSaved_one": "{{count}} upravená faktura",
      "invoiceSaved_few": "{{count}} upravené faktury",
      "invoiceSaved_other": "{{count}} upravených faktur"
    }
  }
}
